var _rect, _path, _path2, _rect2, _g, _path3, _path4, _g2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3696)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3696)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2754_3696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2754_3696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.44061 12.4582L1.40632 14.123L13.0021 1.81011L14.5037 -0.663855L11.4594 -1.22029L6.72974 4.08571L2.92288 7.66071L-1.44061 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.05084 13.6247L0.399539 14.5908L13.9645 -0.893656H11.928L-1.05084 13.6247Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3781 12.4582L11.5311 14.123L-0.0646162 1.81011L-1.56631 -0.663855L1.47808 -1.22029L6.2077 4.08571L10.0146 7.66071L14.3781 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2809 13.2956L12.8305 14.2617L7.05439 7.63201L5.3419 6.89129L-1.71083 -0.655139H0.325672L7.37444 6.71217L9.24675 7.60037L14.2809 13.2956Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-1_2754_3696",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 15,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -1,
    width: 15,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73887 0V-0.75H4.98887V0H5.73887ZM7.17637 0H7.92637V-0.75H7.17637V0ZM5.73887 5.75V6.5H6.48887V5.75H5.73887ZM0 5.75V5H-0.75V5.75H0ZM0 7.66667H-0.75V8.41667H0V7.66667ZM5.73887 7.66667H6.48887V6.91667H5.73887V7.66667ZM5.73887 13.4167H4.98887V14.1667H5.73887V13.4167ZM7.17637 13.4167V14.1667H7.92637V13.4167H7.17637ZM7.17637 7.66667V6.91667H6.42637V7.66667H7.17637ZM12.9375 7.66667V8.41667H13.6875V7.66667H12.9375ZM12.9375 5.75H13.6875V5H12.9375V5.75ZM7.17637 5.75H6.42637V6.5H7.17637V5.75ZM5.73887 0.75H7.17637V-0.75H5.73887V0.75ZM6.48887 5.75V0H4.98887V5.75H6.48887ZM0 6.5H5.73887V5H0V6.5ZM0.75 7.66667V5.75H-0.75V7.66667H0.75ZM5.73887 6.91667H0V8.41667H5.73887V6.91667ZM6.48887 13.4167V7.66667H4.98887V13.4167H6.48887ZM7.17637 12.6667H5.73887V14.1667H7.17637V12.6667ZM6.42637 7.66667V13.4167H7.92637V7.66667H6.42637ZM12.9375 6.91667H7.17637V8.41667H12.9375V6.91667ZM12.1875 5.75V7.66667H13.6875V5.75H12.1875ZM7.17637 6.5H12.9375V5H7.17637V6.5ZM6.42637 0V5.75H7.92637V0H6.42637Z",
    fill: "#F7FCFF",
    mask: "url(#path-10-outside-1_2754_3696)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4077 9.49609H14.2827V9.62109C14.2827 10.1213 14.281 10.6104 14.2793 11.0874C14.2697 13.8294 14.2614 16.1695 14.5901 17.8937C14.7833 18.9074 15.0957 19.7267 15.6072 20.2933C16.1237 20.8654 16.8312 21.1671 17.7821 21.1671C18.7413 21.1671 19.4675 20.7931 20.0054 20.1401C20.5387 19.4926 20.8821 18.5772 21.0989 17.4976C21.5325 15.3389 21.4702 12.4684 21.3482 9.61575L21.3431 9.49609H21.2233H14.4077Z",
    fill: "#B7E1FF",
    stroke: "#F7FCFF",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2754_3696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 8,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4077 9.49609H14.2827V9.62109C14.2827 10.1213 14.281 10.6104 14.2793 11.0874C14.2697 13.8294 14.2614 16.1695 14.5901 17.8937C14.7833 18.9074 15.0957 19.7267 15.6072 20.2933C16.1237 20.8654 16.8312 21.1671 17.7821 21.1671C18.7413 21.1671 19.4675 20.7931 20.0054 20.1401C20.5387 19.4926 20.8821 18.5772 21.0989 17.4976C21.5325 15.3389 21.4702 12.4684 21.3482 9.61575L21.3431 9.49609H21.2233H14.4077Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2754_3696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 18.7837,
    width: 5.175,
    height: 2.3,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2754_3696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.65,
    y: 7.2832,
    width: 10.35,
    height: 6.9,
    fill: "#FDFF00"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.825 13.4934C18.4919 13.4934 19.0325 12.7726 19.0325 11.8834C19.0325 10.9943 18.4919 10.2734 17.825 10.2734C17.1581 10.2734 16.6175 10.9943 16.6175 11.8834C16.6175 12.7726 17.1581 13.4934 17.825 13.4934Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4765 16.1227L15.2469 15.1765C15.2469 15.1765 16.2877 15.0369 16.4104 15.3433C16.5331 15.6496 16.4602 15.2018 16.656 15.905C16.8519 16.6081 16.9294 15.6029 17.0371 16.6081C17.1448 17.6134 17.2359 17.9603 17.2359 18.1942C17.2359 18.428 18.2168 19.1248 17.8406 19.6046C17.4643 20.0845 17.4477 21.19 17.4477 21.5068C17.4477 21.8236 17.4182 21.9655 17.0371 21.8946C16.656 21.8236 16.1926 22.0765 16.1 22.0765C16.0074 22.0765 14.8903 21.7729 14.8903 21.1481C14.8903 20.5234 14.4765 16.1227 14.4765 16.1227Z",
    fill: "#CE6201"
  }))))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3696)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2754_3696",
    x: 12.65,
    y: 7.2832,
    width: 10.35,
    height: 7.1499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2754_3696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2754_3696",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3696",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShp);
export default __webpack_public_path__ + "static/media/SHP.6712a18959a6af6303dab6fd7e45f3e9.svg";
export { ForwardRef as ReactComponent };